module.exports = __webpack_public_path__ + "img/35423.0cc0ff33.jpg";